import {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Input, message, Modal} from "antd";
import {t} from "i18next";
import {isChinese} from "@/utils";
import {fontInfoList, getFontInfo} from "@model/fontInfo";

const DialogRename = forwardRef((props:{onOKEvent:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [content,setContent] = useState('');
    const inputRef = useRef();
    const [itemId,setItemId] = useState('');

    const onShowDialog = (itemId:string,content:string)=>{
        setItemId(itemId);
        setContent(content);
        setIsShowDialog(true);
    }

    return(
        <Modal centered={true}  onCancel={()=>setIsShowDialog(false)} open={isShowDialog} footer={''} afterOpenChange={()=>{
            inputRef.current?.select();
            inputRef.current?.focus();
        }} closable={true} closeIcon={<IconClose/>} width={'460px'} bodyStyle={{margin:'-20px'}}>
            <div style={{display:'flex',flexDirection:'column', alignItems:'center',padding:'16px'}}>
                <span style={{display:'flex',width:'100%'}}>{t("Import custom font")}</span>
                <Input variant={"borderless"} className={'input-border'} ref={inputRef} value={content} onChange={(e)=>setContent(e.currentTarget.value)} style={{marginTop:'16px'}} placeholder={t("Font name")}/>
                <Button className='button-solid-style' onClick={()=>{
                    if (isChinese(content)) {
                        message.error(t('PleaseInputEnglish'))
                        return;
                    }
                    //是否有重名
                    fontInfoList().then(res=>{
                        if (res.filter(p=>(p.fontName == content && p.id != itemId)).length > 0){
                            message.error(t("Font name exist"));
                            return;
                        }
                        setIsShowDialog(false);
                        props.onOKEvent(itemId,content);
                    })

                }} style={{marginTop:'26px',width:'100%',height:'36px',marginBottom:'-16px'}} type={"primary"}>{t("Confirm")}</Button>
            </div>
        </Modal>
    )
})

export default DialogRename;